import { Component, OnInit, Inject } from '@angular/core';
import { Faqconfig } from '../models/faq/faqconfig'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FaqControllerService } from '../rest-proxy/api/faqController.service'

import { FAQEntity } from '../rest-proxy/model/FAQEntity'
import { NgxSpinnerService } from 'ngx-spinner';
import { faqLabel } from '../models/labels/faqLabel';


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {


  labels: faqLabel;
  showdata: FAQEntity[];

  constructor(private spinner: NgxSpinnerService, public dialog: MatDialog, private service_call: FaqControllerService) { }

  ngOnInit() {
    this.labels = new faqLabel();
    this.spinner.show();
    this.getItems();
  }

  getItems() {
    this.service_call.fetchAdminFAqUsingGET().subscribe(data => {

      this.spinner.hide();
      this.showdata = data;
    },
      error => {
        console.log(error);
        this.spinner.hide();
      });
  }

  openDialog(title: string): void {
    const dialogRef = this.dialog.open(viewFAQ, {
      width: '80%',
      height: '80%',
      data: { data: this.showdata, type: title }
    });

    dialogRef.afterClosed().subscribe(result => {


    });
  }

}


@Component({
  selector: 'viewFaq',
  templateUrl: 'viewFaq.html',
})
export class viewFAQ {

  labels: faqLabel;
  constructor(
    public dialogRef: MatDialogRef<viewFAQ>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.labels = new faqLabel();

  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}
